import(/* webpackMode: "eager" */ "/vercel/path0/app/home/error.tsx");
